// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import layoutLeftIcon from "@/assets/icons/layout-left.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type LayoutLeftIconProps = Omit<IconProps, "name">;

export function LayoutLeftIcon(props: LayoutLeftIconProps): React.ReactNode {
  return <Icon name={layoutLeftIcon} {...props} />;
}
